import React from 'react';

const Settings = () => {
    return (
        <svg width={20} height={20} viewBox="0 0 20 20">
            <circle
                cx={2}
                cy={2}
                r={2}
                transform="translate(8 8)"
                fill="none"
                stroke="#8F99DC"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
            />
            <path
                d="M16.055 12.455a1.35 1.35 0 00.27 1.489l.049.049a1.637 1.637 0 11-2.315 2.315l-.049-.049a1.361 1.361 0 00-2.307.965v.139a1.637 1.637 0 11-3.273 0v-.073a1.35 1.35 0 00-.884-1.235 1.35 1.35 0 00-1.489.27l-.049.049a1.637 1.637 0 11-2.315-2.315l.049-.049a1.361 1.361 0 00-.967-2.31h-.139a1.637 1.637 0 110-3.273h.074a1.35 1.35 0 001.235-.884 1.35 1.35 0 00-.27-1.489l-.049-.049a1.637 1.637 0 112.316-2.313l.049.049a1.35 1.35 0 001.489.27h.065a1.35 1.35 0 00.818-1.235v-.14a1.637 1.637 0 113.273 0v.074a1.361 1.361 0 002.307.965l.049-.049a1.637 1.637 0 112.315 2.315l-.049.049a1.35 1.35 0 00-.27 1.489v.065a1.35 1.35 0 001.235.818h.139a1.637 1.637 0 110 3.273h-.072a1.35 1.35 0 00-1.235.82z"
                fill="none"
                stroke="#8F99DC"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
            />
        </svg>
    );
};

export default Settings;
